export default __webpack_public_path__ + "static/media/backgroundLogin.4e2ea823.png";